<template>
  <div class="axure-animated-dots">
    <span class="sr-only">Thinking...</span>
    <span class="axure-dot" aria-hidden="true">.</span>
    <span class="axure-dot" aria-hidden="true">.</span>
    <span class="axure-dot" aria-hidden="true">.</span>
  </div>
</template>

<style scoped>
.axure-animated-dots .axure-dot {
  opacity: 0;
  animation: dot-animation 0.8s infinite;
}

.axure-animated-dots .axure-dot:nth-child(1) {
  animation-delay: 0s;
}

.axure-animated-dots .axure-dot:nth-child(2) {
  animation-delay: 0.1s;
}

.axure-animated-dots .axure-dot:nth-child(3) {
  animation-delay: 0.2s;
}

@keyframes dot-animation {
  0%, 20% {
    opacity: 0;
  }
  30%, 70% {
    opacity: 1;
  }
  80%, 100% {
    opacity: 0;
  }
}
</style>
